import { ComboInput } from '../../../baseInputs/ComboInput';
import { TextColorInput } from './TextColorInput';
import { TextShadowInput } from './TextShadowInput';
import { TextDecorationInput } from './TextDecorationInput';
import { useScene } from '../../../../../context/sceneContext';

export const TextComboInput = () => {
  const scene = useScene();

  const data = scene.getSelectedElementsData({
    color: undefined,
    textDecoration: undefined,
    textShadow: undefined,
  });

  const updateData = (props: { [key: string]: any }) =>
    scene.updateSelectedElementsData(props, undefined, 'textComboInput');

  return (
    <ComboInput
      label="Text"
      inputs={[
        {
          name: 'Text Color',
          children: <TextColorInput value={data.color} onChange={(newValue) => updateData({ color: newValue })} />,
          isVisible: data.color !== undefined,
          onAdd: () => updateData({ color: '#219fb5' }),
          onRemove: () => updateData({ color: undefined }),
        },
        {
          name: 'Text Decoration',
          children: <TextDecorationInput value={data.textDecoration} onChange={(newValue?: string) => updateData({ textDecoration: newValue })} />,
          isVisible: data.textDecoration !== undefined,
          onAdd: () => updateData({ textDecoration: 'underline' }),
          onRemove: () => updateData({ textDecoration: undefined }),
        },
        {
          name: 'Text Shadow',
          children: (
            <TextShadowInput value={data.textShadow} onChange={(newValue) => updateData({ textShadow: newValue })} />
          ),
          isVisible: data.textShadow !== undefined,
          onAdd: () => updateData({ textShadow: '0px 0px 4px #000000' }),
          onRemove: () => updateData({ textShadow: undefined }),
        },
      ]}
    />
  );
};
